import ajax from "../assets/uilt/ajax";

let agentThreshold = {
  toggleDistributorMode: (req) => {
    return ajax.post({
      url: "/back/agent-threshold/toggle-distributor-mode",
      param: req.param,
      success: req.success,
    });
  },
  listAgentThresholdsByOrg: (req) => {
    return ajax.get({
      url: "/back/agent-threshold/list-by-org",
      param: req.param,
      success: req.success,
    });
  },
};

export default agentThreshold;
